import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSliderModule } from '@angular/material/slider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { QueueComponent } from './queue/queue.component';
import { FloatingPlayerComponent } from './floating-player/floating-player.component';
import { ExpandedPlayerDialogComponent } from './floating-player/expanded-player-dialog/expanded-player-dialog.component';
import { DeviceSelectorDialogComponent } from './floating-player/device-selector-dialog/device-selector-dialog.component';
import { KeyboardShortcutsHelpComponent } from '../../shared/components/keyboard-shortcuts-help/keyboard-shortcuts-help.component';
import { TrackRatingButtonComponent } from '../../shared/components/track-rating-button/track-rating-button.component';

@NgModule({
  declarations: [
    QueueComponent,
    FloatingPlayerComponent,
    ExpandedPlayerDialogComponent,
    DeviceSelectorDialogComponent,
    KeyboardShortcutsHelpComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatSliderModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDialogModule,
    MatSnackBarModule,
    DragDropModule,
    TrackRatingButtonComponent,
    RouterModule.forChild([
      { path: 'queue', component: QueueComponent }
    ])
  ],
  exports: [
    QueueComponent,
    FloatingPlayerComponent,
    ExpandedPlayerDialogComponent
  ]
})
export class PlayerModule { }